import React from 'react';

import { staticRoutes } from 'Deer/constants/routes';
import { PageNotFound404 } from 'Deer/pages/PageNotFound404';
import AdminOrManagerRoute from 'components/AdminOrManagerRoute';
import { Route, Switch } from 'react-router-dom';
import HRISPlugin from 'screens/admin/Plugins/HRIS';
import JiraPlugin from 'screens/admin/Plugins/Jira';
import MSTeamsPlugin from 'screens/admin/Plugins/MSTeams';
import SlackPlugin from 'screens/admin/Plugins/Slack';
import { checkSettingsPageRevampEnabled } from 'utils/helpers/featureFlags';

import { FEATURE_KEYS, PLATFORM_ADMIN } from 'constants/ProjectConstants';

import HRISPluginIntent from '../EmployeeRoster/HRISPluginIntent';
import MSTeamsPluginIntent from './MSTeamsPluginIntent';
import SlackPluginIntent from './SlackPluginIntent';

// eslint-disable-next-line arrow-body-style
const PluginSettings = () => {
  return (
    <Switch>
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.plugins.slack}
        component={checkSettingsPageRevampEnabled() ? SlackPluginIntent : SlackPlugin}
        redirectionPath={staticRoutes.home}
        roles={[PLATFORM_ADMIN]}
      />
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.plugins.jira}
        component={JiraPlugin}
        redirectionPath={staticRoutes.home}
        featureKey={FEATURE_KEYS.GOAL}
        roles={[PLATFORM_ADMIN]}
      />
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.plugins.msteams}
        component={checkSettingsPageRevampEnabled() ? MSTeamsPluginIntent : MSTeamsPlugin}
        redirectionPath={staticRoutes.home}
        roles={[PLATFORM_ADMIN]}
      />

      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.plugins.hris}
        component={checkSettingsPageRevampEnabled() ? HRISPluginIntent : HRISPlugin}
        redirectionPath={staticRoutes.home}
        roles={[PLATFORM_ADMIN]}
      />
      <Route path="*" component={PageNotFound404} />
    </Switch>
  );
};

export default PluginSettings;
